import { render } from "./SubjectProfile.vue?vue&type=template&id=4017be0c&scoped=true"
import script from "./SubjectProfile.js?vue&type=script&lang=js"
export * from "./SubjectProfile.js?vue&type=script&lang=js"

import "./SubjectProfile.vue?vue&type=style&index=0&id=4017be0c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4017be0c"]])

export default __exports__